import { render, staticRenderFns } from "./uno.vue?vue&type=template&id=5fa29909&"
import script from "./uno.vue?vue&type=script&lang=js&"
export * from "./uno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports